export default __webpack_public_path__ + "images/assets/3afe2113702fbf7bc0d9b8a6432d2069.svg";